import React from 'react'
import PropTypes from 'prop-types'
import glamorous from 'glamorous'
import { formatDate } from 'transfer/utils/date-utils'
import { MGM } from 'transfer/constants'
import content from 'pp-react-l10n'
import { tracking } from 'lib/analytics/mParticle'
import Events from 'lib/analytics/eventTags'
import { hasMgmHideEndDateTreatment, hasMgmTreatmentTwo } from 'experiments/mgm'
import { Link, CaptionText } from '@paypalcorp/pp-react'
import { isDw2Repaint } from '../../../experiments/dw2Repaint'
import { get } from 'lodash'
import { connect } from 'transfer/utils/p2p-connect'

const i18n = content('transfer/page/mgm')

const LinkContainer = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '14px',
  marginBottom: '1rem',
  '> *': {
    margin: '0.15rem',
  },
})

// hasMgmTreatmentTwo is used for hiding end date for users
// hasMgmHideEndDateTreatment is used for hiding end date for GUID flows but will
// also work on users.
const hideEndDate = hasMgmTreatmentTwo() || hasMgmHideEndDateTreatment()

// Props
// @timeZone - Timezone of user to format date properly
// @usePeriod - Flag to use period at the end of link

function MGMTermsLink(props) {
  const { timeZone, onClick, usePeriod = false } = props
  const mgmPSContent = get(
    props.pStudioContent,
    'mgm_referee_growth_touchpoint.content.json',
    {}
  )

  const formattedDate =
    !hideEndDate &&
    formatDate(new Date(MGM.PROMO_EXPIRY_DATE), {
      timeZone,
    })

  // onClick can be a customized function passed as a prop
  // or default to p2p_mgm_terms_pressed tracking event.
  let onClickFunction = () => tracking(Events.p2p_mgm_terms_pressed())

  // If onClick is overridden (passed as a prop), use that instead
  if (onClick) {
    onClickFunction = onClick
  }

  return (
    <LinkContainer>
      {isDw2Repaint() ? (
        <>
          {!hideEndDate && (
            <CaptionText as="span">
              {i18n('mgm.unilateral.endDate', { formattedDate })}
            </CaptionText>
          )}
          <Link
            href={mgmPSContent.terms_link}
            target="_blank"
            size="sm"
            data-pagename=""
            onClick={onClickFunction}
          >
            {hideEndDate && !usePeriod
              ? mgmPSContent.terms_link_title
              : i18n('mgm.descLink')}
          </Link>
        </>
      ) : (
        <>
          {!hideEndDate && (
            <span>{i18n('mgm.unilateral.endDate', { formattedDate })}</span>
          )}
          <a
            className="ppvx_link"
            onClick={onClickFunction}
            href={mgmPSContent.terms_link}
            target="_blank"
          >
            {hideEndDate && !usePeriod
              ? mgmPSContent.terms_link_title
              : i18n('mgm.descLink')}
          </a>
        </>
      )}
    </LinkContainer>
  )
}

MGMTermsLink.propTypes = {
  timeZone: PropTypes.string,
  usePeriod: PropTypes.any,
  onClick: PropTypes.func,
  pStudioContent: PropTypes.object,
}

export default connect(({ server }) => ({
  pStudioContent: server.pStudioContent,
}))(MGMTermsLink)
